import { Component, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

import { DialogComponent } from '../../../ui/dialog/dialog';

import { ApiProvider } from '../../../providers/api/api';
import { HelpersProvider } from '../../../providers/helpers/helpers';
import { AuthService } from '../../../providers/auth/auth.service';
import { CustomerProvider } from '../../../providers/customer/customer';
import { UserProvider } from '../../../providers/user/user';
import { I18nProvider } from '../../../providers/i18n/i18n';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'component-customer-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class CustomerFeedbackComponent implements OnChanges {
  protected headers: any;
  @Input() studentData: any = null;
  @Input() user: any = null;
  @Input() studentSelected: any = null;

  @Output() closeFeedback = new EventEmitter<void>();
  search = '';
  selectedFeedback: any = null;
  loadError = false;
  private requestVersion = 0;

  get filteredFeedbacks(): any[] {
    const term = this.helpers.removeDiacritics(this.search.trim().toLowerCase());
    return (this.feedbacks || []).filter(item => !term || this.helpers.removeDiacritics(
      [item.program_name || '', item.training_name || '', item.feedback || ''].join(' ').toLowerCase()
    ).includes(term));
  }

  feedbackDate(item: any): string {
    if (!item.created_at) return 'Data não informada';
    const date = new Date(this.helpers.normalizeDate(item.created_at));
    return isNaN(date.getTime()) ? 'Data não informada' : date.toLocaleDateString(
      this.STRINGS.lang === 'en' ? 'en-US' : this.STRINGS.lang === 'es' ? 'es-ES' : 'pt-BR'
    );
  }

  loading: boolean = false;
  feedbacks = [];

  PAGE: any;
  STRINGS: any;
  ENV: any;

  constructor(
    public toastr: ToastrService,
    public auth: AuthService,
    public api: ApiProvider,
    public helpers: HelpersProvider,
    public dialog: MatDialog,
    public studentProv: CustomerProvider,
    public userProv: UserProvider,
    public i18n: I18nProvider,
  ) {
    this.STRINGS = this.i18n.translate();
    this.PAGE = this.i18n.translate('DashboardFeedbacksComponent');

    this.headers = {'Authorization': `Bearer ${localStorage.getItem('LoggedInUser')}`};
    this.ENV = environment;
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.studentData) {
      this.search = '';
      this.selectedFeedback = null;
      this.getFeedbacks(this.studentData && this.studentData.id);
    }
  }

  async getFeedbacks(id: any = 0) {
    const version = ++this.requestVersion;
    this.feedbacks = [];
    this.selectedFeedback = null;
    this.loadError = false;
    if (!id) { this.loading = false; return; }
    this.loading = true;
    try {
      const res: any = await this.studentProv.getFeedbacks(id);
      if (version !== this.requestVersion) return;
      this.feedbacks = (res.feedbacks || []).slice().sort((a, b) => String(b.created_at || '').localeCompare(String(a.created_at || '')));
    } catch (error) {
      if (version !== this.requestVersion) return;
      this.loadError = true;
      this.toastr.error(this.STRINGS.algo_errado, '', this.helpers.toastrCfgs);
    } finally {
      if (version === this.requestVersion) this.loading = false;
    }
  }

  toggleClass(item: any) {
    item.active = !item.active;
  }

  openFeedback(f: any = null) {
    const title = this.PAGE.feedback_title;
    const inner_msg = '' +
      '<p>'+this.PAGE.aluno+': '+f.customer_name+'</p>' +
      '<p>'+this.PAGE.titulo_programa+': '+f.program_name+'</p>' +
      '<p>'+this.PAGE.titulo_treino+': '+f.training_name+'</p>' +
      '<pre>'+this.PAGE.feedback+': '+f.feedback+'</pre>' +
      '';
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '90%',
      panelClass: 'mat-dialog-feedback-details',
      data: {title: title, inner_msg: inner_msg, confirmation: 'deletar', bt_cancel_hide: true}
    });
  }

}
